import React from 'react'
// import { Link} from 'react-router-dom'

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-body">
                <div>
                    © {new Date().getFullYear()} <span className="footer-brand">BPPMHKP</span> · Kementerian Kelautan dan Perikanan Republik Indonesia
                </div>
                <div>
                    SIAPMUTU · Sistem Informasi Aplikasi Pelayanan Mutu
                </div>
            </div>
        </footer>
    )
}

export default Footer
